const routes = [
  { link: "/", name: "Home" },
  { link: "/testimony", name: "Testimony" },
  { link: "/projects", name: "Projects" },
  { link: "/our-story", name: "Our Story" },
  { link: "/team", name: "Our Team" },
  // { link: "/cyberSecurity", name: "CyberSecurity Promo" },
  { link: "https://cefcodev.vercel.app/", name: "Foundation" },
  { link: "/workshop", name: "Workshop" },
  { link: "/kids", name: "kids" },
];

export default routes;
